<template>
    <div class="second-row">

        <!-- >>> Times -->
        <div class="time">
            <div class="take-off col-sm-4">
                <div class="icon">
                    <i class="soap-icon-plane-right yellow-color" v-if="flight.prcs[0] !== undefined"></i>
                    <i class="soap-icon-plane-right silver-color" v-if="flight.prcs[0] === undefined"></i>
                </div>
                <div>
                    <span v-bind:class="{ 'skin-color': flight.prcs[0] !== undefined }">{{ takeoff[getCurrentLocale] }}</span>
                    <br>
                    {{ flight.depDT | moment }}{{ uhr[getCurrentLocale] }}
                </div>
            </div>
            <div class="landing col-sm-4">
                <div class="icon">
                    <i class="soap-icon-plane-right yellow-color" v-if="flight.prcs[0] !== undefined"></i>
                    <i class="soap-icon-plane-right silver-color" v-if="flight.prcs[0] === undefined"></i>
                </div>
                <div>
                    <span v-bind:class="{ 'skin-color': flight.prcs[0] !== undefined }">{{ landing[getCurrentLocale] }}</span>
                    <br>
                    {{ flight.desDT | moment }}{{ uhr[getCurrentLocale] }}
                </div>
            </div>
            <div class="total-time col-sm-4">
                <div class="icon">
                    <i class="soap-icon-clock yellow-color" v-if="flight.prcs[0] !== undefined"></i>
                    <i class="soap-icon-clock silver-color" v-if="flight.prcs[0] === undefined"></i>
                </div>
                <div>
                    <span v-bind:class="{ 'skin-color': flight.prcs[0] !== undefined }">{{ totaltime[getCurrentLocale] }}</span>
                    <br>
                    {{ flight.dur | durationFlight }}
                </div>
            </div>
        </div>
        <!-- <<< Times -->


        <!-- >>> 'Select Flight' Button(s)  -->
        <!-- >>> Button: ON/SELECTED -->
        <div v-if="flightdirection === 'outward' && flight.prcs[0] !== undefined && flight.warn === ''" class="action">
            <!-- Button: ON -->
            <a href="#" @click.prevent="flightSelected({ flight: flight, type: 'outward', modulo: modulo })" class="button btn-small full-width xgreen" v-if="getBookingFlightIdSelectedOutward !== flight.id">{{ selectflight[getCurrentLocale] }}</a>
            <!-- Button: SELECTED -->
            <a class="button btn-small full-width sundair" v-if="getBookingFlightIdSelectedOutward === flight.id">{{ selectflight[getCurrentLocale] }}</a>
        </div>
        <div v-if="flightdirection === 'return' && flight.prcs[0] !== undefined && flight.warn === ''" class="action">
            <!-- Button: ON -->
            <a href="#" @click.prevent="flightSelected({ flight: flight, type: 'return', modulo: modulo })" class="button btn-small full-width xgreen" v-if="getBookingFlightIdSelectedReturn !== flight.id">{{ selectflight[getCurrentLocale] }}</a>
            <!-- Button: SELECTED -->
            <a class="button btn-small full-width sundair" v-if="getBookingFlightIdSelectedReturn === flight.id">{{ selectflight[getCurrentLocale] }}</a>
        </div>
        <!-- <<< Button: ON/SELECTED -->

        <!-- >>> Button: OFF/OUT -->
        <div class="action" v-if="flight.prcs[0] === undefined || flight.warn === 'LC_WARNING_INSUFFICIENT_INF_SERVICE_AVAILABILITY'">
            <a class="button btn-small full-width silver" style="color: rgba(0,0,0,.075); background: #F9F9F9;">{{ selectflight[getCurrentLocale] }}</a>
        </div>
        <!-- <<<< Button: OFF/OUT -->
        <!-- <<< 'Select Flight' Button(s)  -->
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';


    export default {

        /* >>> *************************************************************** / /* Props */
        props: ['flight', 'flightdirection', 'modulo'],
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* Data */
        data: function() {

            return {
                uhr: {
                    en: " o'clock",
                    de: ' Uhr'
                },
                selectflight: {
                    en: 'SELECT FLIGHT',
                    de: 'FLUG WÄHLEN',
                },
                // ----------------------------------------
                out: {
                    en: 'SOLD OUT',
                    de: 'AUSV.'
                },
                // ----------------------------------------
                selectbookedflight: {
                    en: 'MY NEW FLIGHT',
                    de: 'MEIN NEUER FLUG',
                },
                // ----------------------------------------
                takeoff: {
                    en: 'Take off',
                    de: 'Abflug',
                },
                landing: {
                    en: 'Landing',
                    de: 'Ankunft',
                },
                totaltime: {
                    en: 'total time',
                    de: 'Dauer',
                },
                to: {
                    en: 'to',
                    de: 'nach',
                },
            };

        }, // eo data
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                'getBookingFlightIdSelectedOutward',
                'getBookingFlightIdSelectedReturn',
            ]),

        }, // eo computed
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Filters */
        filters: {

            /*******************************************************************
            * durationFlight()
            *
            * Desc: Calculates "Travel Time".
            *
            * @param {int} a (duration in seconds)
            * @return {string}
            */
            durationFlight: function(a) {

                let hours = Math.floor(a / 3600),
                    minutes = Math.floor(a / 60) - hours * 60,
                    hours_txt = 'S', // H
                    minutes_txt = ' h'; // M


                if (minutes === 0) {
                    return hours + ':00' + minutes_txt;
                } else if (minutes.toString().length === 1) {
                    return hours + ':0' + minutes + '' + minutes_txt;
                } else {
                    return hours + ':' + minutes + '' + minutes_txt;
                }

            }, // eof durationFlight()

        }, // eof filters{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_setBookingUpdateCart',
            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * flightSelected()
            *
            * Desc: Flight selected! Call ACTION(s)!
            * Note: Param 'flight' has: 'flight', 'type', 'modulo'.
            * Note: Watches 'modulo'!
            *
            * @param {Object} flight (selected Flight)
            * @return {string}
            */
            flightSelected: function(flight) {

                var me = this;


                me.$toc('>>> shared/flightsearch/components/secondrow/SecondRowBooking.vue >>> flightSelected');
                this.actn_setBookingUpdateCart(flight);

            }, // eof flightSelected()

        }, // eo methods{}
        /* <<< ****************************************************************/

    };
</script>



// WEBPACK FOOTER //
// src/components/shared/flightsearch/components/fsr/secondrow/SecondRowBooking.vue